// Single source of truth for the backend base URL.
// Override locally/in Netlify by setting VITE_API_URL; otherwise falls back
// to the deployed Render backend.
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://ebesohadriantaleh.onrender.com';
